import { render, staticRenderFns } from "./OptimizacionProduccionMoldes.vue?vue&type=template&id=7476bfdc&scoped=true&"
import script from "./OptimizacionProduccionMoldes.vue?vue&type=script&lang=js&"
export * from "./OptimizacionProduccionMoldes.vue?vue&type=script&lang=js&"
import style0 from "./OptimizacionProduccionMoldes.vue?vue&type=style&index=0&id=7476bfdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7476bfdc",
  null
  
)

export default component.exports